import { selector } from 'lib/selectors';
import { createTreeFromNestedSet, getRootItems } from './helpers';

const categories = (state) => state.payCategories;

export const payCategoriesListSelector = selector(categories, (c) => c.list);

export const payRootCategoriesListSelector = selector(payCategoriesListSelector, getRootItems);

export const payCategoriesTreeSelector = selector(payCategoriesListSelector, createTreeFromNestedSet);
